import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=f6464160&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"
import style0 from "./banner.vue?vue&type=style&index=0&id=f6464160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6464160",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/scene/banner.vue
// module id = null
// module chunks = 